import { ApiResponse } from "@/types";
import {
  CreateProjectPayload,
  CreateProjectData,
  Project,
  ProjectDetailsData,
  AddToProjectPayload,
  RemoveFromProjectPayload,
  ProjectMatchesData,
  InterestPayload,
  UpdateProjectPayload,
  UpdateProjectData,
} from "@/types/project";
import { axiosWithToken } from "@/utils/axios";
import { AxiosResponse } from "axios";

class ServiceClass {
  CreateProject(
    payload: CreateProjectPayload,
  ): Promise<AxiosResponse<ApiResponse<CreateProjectData>>> {
    return axiosWithToken().post("/projects", payload);
  }

  GetProjects(): Promise<AxiosResponse<ApiResponse<Project[]>>> {
    return axiosWithToken().get("/projects");
  }

  GetProjectById(
    projectId: string,
  ): Promise<AxiosResponse<ApiResponse<ProjectDetailsData>>> {
    return axiosWithToken().get(`/projects/${projectId}`);
  }

  UpdateProject(
    projectId: string,
    payload: UpdateProjectPayload,
  ): Promise<AxiosResponse<ApiResponse<UpdateProjectData>>> {
    return axiosWithToken().patch(`/projects/${projectId}`, payload);
  }

  DeleteProject(projectId: string): Promise<AxiosResponse<ApiResponse<any>>> {
    return axiosWithToken().delete(`/projects/${projectId}`);
  }

  DeactivateProject(
    projectId: string,
  ): Promise<AxiosResponse<ApiResponse<any>>> {
    return axiosWithToken().patch(`/projects/${projectId}/deactivate`);
  }

  AddPropertyToProject(
    projectId: string,
    payload: AddToProjectPayload,
  ): Promise<AxiosResponse<ApiResponse<any>>> {
    return axiosWithToken().patch(`/projects/${projectId}/add`, payload);
  }

  RemovePropertyFromProject(
    projectId: string,
    payload: RemoveFromProjectPayload,
  ): Promise<AxiosResponse<ApiResponse<any>>> {
    return axiosWithToken().delete(`/projects/${projectId}/remove`, {
      data: payload,
    });
  }

  GetProjectSuggestions(
    projectId: string,
  ): Promise<AxiosResponse<ApiResponse<any[]>>> {
    return axiosWithToken().get(`/projects/${projectId}/suggestions`);
  }

  GetProjectMatches(
    projectId: string,
    tier?: "matches" | "recommendations",
  ): Promise<AxiosResponse<ApiResponse<ProjectMatchesData>>> {
    return axiosWithToken().get(`/projects/${projectId}/matches`, {
      params: tier ? { tier } : undefined,
    });
  }

  IndicateInterest(
    projectId: string,
    propertyId: string,
    payload: InterestPayload,
  ): Promise<AxiosResponse<ApiResponse<any>>> {
    return axiosWithToken().post(
      `/projects/${projectId}/matches/${propertyId}/interest`,
      payload,
    );
  }
}

const ProjectService = new ServiceClass();
export default ProjectService;
